import React from 'react';
import { connect } from 'react-redux';
import { checkAccess, ids } from '../../../../helpers/rolAccess';
import { loadTabs } from '../../../Header/actions';
import Resumen from './Resumen/view';
import Siniestros from './Siniestros/view';
import Denuncias from './Denuncias/view';
import PrestacionesEconomicas from './PrestacionesEconomicas/view';
import Disclaimer from './Disclaimer/Disclaimer';
import { doPostTagManagerApi } from '../SiniestrosEmpresa/Siniestros/actions';
import jwtDecode from 'jwt-decode';

class SiniestrosEmpresa extends React.PureComponent {
  componentDidUpdate = (prevProps) => {
    if (
      (prevProps.userAccessIds === null && Array.isArray(this.props.userAccessIds)) ||
      this.props.currentHeader !== 'Siniestros'
    ) {
      this.loadTabs();
    }
    if (
      prevProps.sucursalId !== this.props.sucursalId ||
      prevProps.companyId !== this.props.companyId
    ) {
      if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds)) {
        this.loadTabs();
      }
    }
  };

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.resumenSiniestro, this.props.userAccessIds))
      tabs.push({ text: 'General', contentId: 0 });
    if (checkAccess(ids.siniestroEmpresa, this.props.userAccessIds))
      tabs.push({ text: 'Siniestros', contentId: 1 });
    if (checkAccess(ids.denunciasEmpresa, this.props.userAccessIds))
      tabs.push({ text: 'Denuncias', contentId: 2 });
    if (checkAccess(ids.prestacionesEmpresa, this.props.userAccessIds))
      tabs.push({ text: 'Prestaciones económicas', contentId: 3 });

    this.props.dispatch(
      loadTabs(
        'Siniestros',
        'Visualizarás información de los accidentes y/o enfermedades profesionales de tus trabajadores de los últimos 12 meses, y además podrás gestionar sus siniestros. Si deseas buscar siniestros con un marco temporal mayor a este, podrás utilizar las herramientas de búsqueda de la pestaña Siniestros.',
        tabs,
        tabs.length ? tabs[0].contentId : null,
      ),
    );
  };

  showDisclaimer() {
    if (this.props.currentRoles) {
      const company = this.props.companyId;
      let currentRoles;

      Object.keys(this.props.currentRoles).forEach((key) => {
        if (key === company) currentRoles = this.props.currentRoles[key];
      });

      let isAbleToSeeBanner = false;
      const rolesWithAccess = [
        'Admin',
        'Admin ACHS Virtual',
        'Administrador SEL',
        'Autoasignacion ACHS',
        'Contact Center',
        'Full',
        'Soporte SEL',
        'Trabajador ACHS',
      ];

      if (!currentRoles) return <></>;

      currentRoles.forEach((rol) => {
        if (rolesWithAccess.includes(rol)) {
          isAbleToSeeBanner = true;
        }
      });

      currentRoles.forEach((rol) => {
        if (rol === 'Siniestros') {
          isAbleToSeeBanner = false;
        }
      });

      if (isAbleToSeeBanner) {
        return <Disclaimer companyId={this.props.companyId} />;
      }
    }

    return <></>;
  }

  postTagManager({ label, response }, dispatch) {
    const token = localStorage.getItem('AccessToken');
    let azureObjectId;
    if (token) {
      const tokenDecoded = jwtDecode(`Bearer ${token}`);
      azureObjectId = tokenDecoded.sub.toLowerCase();
    }
    dispatch(
      doPostTagManagerApi({
        action: 'Siniestros empresa',
        label,
        category: 'Empresa',
        id: azureObjectId,
        response: response || '',
      }),
    );
  }

  renderBody = () => {
    switch (this.props.selectedTab) {
      case 0: {
        this.postTagManager({
          label: 'Clic Btn: Siniestros empresa - General'
        }, this.props.dispatch);
        return (
          <React.Fragment>
            <Resumen key='resumen' />
          </React.Fragment>
        );
      }
      case 1: {
        this.postTagManager({
          label: 'Clic Btn: Siniestros empresa - Siniestros'
        }, this.props.dispatch);
        return (
          <React.Fragment>
            {this.showDisclaimer()}
            <Siniestros postTagManager={this.postTagManager} />
          </React.Fragment>
        );
      }
      case 2: {
        return (
          <React.Fragment>
            <Denuncias />
          </React.Fragment>
        );
      }
      case 3: {
        return <PrestacionesEconomicas />;
      }
      default:
        return <div />;
    }
  };

  render() {
    return <React.Fragment>{this.renderBody()}</React.Fragment>;
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  currentRoles: state.global.myCompanyRoles,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SiniestrosEmpresa);
